import LegalLayout from "@/pages/legal/LegalLayout";

const SECTIONS = [
  {
    id: "introduction",
    label: "Introduction",
    body: [
      "By accessing or using this website, you agree to these Terms of Use. If you do not agree, please do not use the website. These Terms apply to anyone who visits, browses, or interacts with the Erenown website.",
    ],
  },
  {
    id: "about",
    label: "About the Website",
    body: [
      "The website presents information about Erenown, its entities, structures, brand lines, capabilities, and related business activities. It is intended for general professional and informational use.",
    ],
  },
  {
    id: "permitted-use",
    label: "Permitted Use",
    body: [
      "You may browse the site, review the content, and submit genuine business enquiries through the contact channels provided. Reasonable caching by browsers and ordinary copying for personal, non-commercial reference purposes are permitted.",
    ],
  },
  {
    id: "prohibited-use",
    label: "Prohibited Use",
    body: [
      "You agree not to:",
      {
        type: "list",
        items: [
          "use the website for any unlawful purpose",
          "misuse contact forms or submit false, misleading, or abusive content",
          "interfere with the website’s operation, integrity, or security",
          "copy, reproduce, or otherwise exploit the website’s content beyond ordinary viewing",
          "attempt unauthorized access to any part of the website or its underlying systems",
          "engage in any fraudulent, deceptive, or harmful activity",
        ],
      },
    ],
  },
  {
    id: "informational",
    label: "Informational Nature / No Reliance",
    body: [
      "Website content is provided for general informational purposes only. It does not constitute, and should not be relied upon as, legal, tax, investment, regulatory, or other binding professional advice. Specific matters should always be considered on their own facts.",
    ],
  },
  {
    id: "no-contract",
    label: "No Automatic Contract",
    body: [
      "Use of the website, submission of a contact request, or viewing of brand or service information does not by itself create a contractual relationship between you and Erenown. Any commercial engagement is established only through a clearly defined, separately agreed arrangement.",
    ],
  },
  {
    id: "ip",
    label: "Intellectual Property",
    body: [
      "The website’s content, structure, design elements, text, brand elements, and related materials belong to Erenown or are used with appropriate rights. No reproduction, redistribution, or other reuse is permitted without prior written consent, except for normal website viewing.",
    ],
  },
  {
    id: "structures",
    label: "Erenown Structures and Brands",
    body: [
      "The website may refer to Erenown entities, brands, lines, and business concepts. Their appearance on the site does not by itself create separate public offers, legal commitments, or standalone contractual obligations unless expressly stated.",
    ],
  },
  {
    id: "external-links",
    label: "External Links",
    body: [
      "The website may include links to third-party websites for convenience. Erenown does not control and is not responsible for the content, availability, accuracy, or practices of any external website.",
    ],
  },
  {
    id: "availability",
    label: "Website Availability",
    body: [
      "Erenown may update, suspend, or modify the website or any of its content at any time without notice. Uninterrupted availability is not guaranteed, and access may be limited in connection with maintenance, security, or operational requirements.",
    ],
  },
  {
    id: "liability",
    label: "Limitation of Liability",
    body: [
      "To the fullest extent permitted by applicable law, Erenown excludes liability for indirect or consequential loss, reliance on website content, or interruption of website availability arising from use of the website. Nothing in these Terms limits liability that cannot be excluded under applicable mandatory law.",
    ],
  },
  {
    id: "governing-law",
    label: "Governing Law",
    body: [
      "These Terms of Use are governed by the laws of England and Wales, unless mandatory law requires otherwise.",
    ],
  },
  {
    id: "contact",
    label: "Contact",
    body: [
      "For questions regarding these Terms of Use, please write to:",
      { type: "mono", lines: ["info@erenown.com"] },
    ],
  },
];

export default function TermsOfUse() {
  return (
    <LegalLayout
      eyebrow="Terms of Use"
      title="Terms of Use."
      originallyPublished="01 September 2020"
      lastUpdated="16 October 2021"
      intro="The terms under which the Erenown website may be accessed and used — written for clarity, business awareness, and proper protection of both the visitor and Erenown."
      sections={SECTIONS}
    />
  );
}
